import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TableComponent } from "../../../../shared/component/table/table.component";
import { TableDataPaginationService, TableDataPayload } from '../../../../shared/component/table/table.service';
import { DestroyableComponent } from '../../../../shared/services/destroyable.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-analytictables',
  imports: [TableComponent],
  templateUrl: './analytictables.component.html',
  styleUrl: './analytictables.component.scss'
})
export class AnalytictablesComponent extends DestroyableComponent implements OnInit, OnChanges{

  // 🔹 Which report this instance shows: 'DG' | 'GRID' | 'GridOverload' | 'DGOverload'
  //    | 'zeroReading' | 'lowbalance' | 'sensorCutOff' | 'cbNotConnected' | 'dlNotConnected'
  @Input() reportType!: string;
  @Input() site_id: string | null = '';
  @Input() timer!: number | string;

  showtable = false;
  totalCount = 0;

  TableHeader = '';
  ExportFileName = '';
  spanrowParam = '';

  constructor(
    private tableDataPaginationService: TableDataPaginationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.tableDataPaginationService.showTable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(v => this.showtable = v);

    this.tableDataPaginationService.totalCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(c => this.totalCount = c);

    this.loadReport();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Re-run when the report type or its dependent filters change
    if (changes['reportType'] || changes['site_id'] || changes['timer']) {
      if (!changes['reportType']?.firstChange) {
        this.loadReport();
      }
    }
  }

  // 🔹 Map reportType -> TableDataPayload (same mapping as the old fetchData switch)
  private buildPayload(): TableDataPayload | null {
    switch (this.reportType) {
      case "DG":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'DG Data';
        this.TableHeader = 'DG On';
        return { time: this.timer, type: 'DGON', view_type: 'L', site_id: this.site_id };

      case "GRID":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'Grid Data';
        this.TableHeader = 'Grid On';
        return { time: this.timer, type: 'GRIDON', view_type: 'L', site_id: this.site_id };

      case "GridOverload":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'Grid-Overload Data';
        this.TableHeader = 'Grid Overload';
        return { time: this.timer, type: 'OVERLOAD-GRID', view_type: 'L', site_id: this.site_id };

      case "DGOverload":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'DG-Overload Data';
        this.TableHeader = 'DG Overload';
        return { time: this.timer, type: 'OVERLOAD-DG', view_type: 'L', site_id: this.site_id };

      case "zeroReading":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'Zero Reading Data';
        this.TableHeader = 'Zero Reading';
        return { time: this.timer, type: 'SENSORZEROREADING', view_type: 'L', site_id: this.site_id };

      case "lowbalance":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'Low Balance Data';
        this.TableHeader = 'Low Balance';
        return { time: this.timer, type: 'LOW-BALANCE', view_type: 'L', site_id: this.site_id };

      case "sensorCutOff":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'Meter Cut Off Data';
        this.TableHeader = 'Meter Cut Off';
        return { time: this.timer, type: 'SENSORCUTOFF-L', view_type: '', site_id: this.site_id };

      case "cbNotConnected":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'CB Not Connected Data';
        this.TableHeader = 'CB Not Connect Since';
        return { time: this.timer, type: 'CBNOTCONNECT', view_type: 'L', site_id: this.site_id };

      case "dlNotConnected":
        this.spanrowParam = "short_code";
        this.ExportFileName = 'Gateway Not Connected Data';
        this.TableHeader = 'Gateway Not Connect';
        return { time: this.timer, type: 'DLNOTCONNECT', view_type: 'L', site_id: this.site_id };

      default:
        return null;
    }
  }

  private loadReport(): void {
    const payload = this.buildPayload();

    if (!payload) {
      this.tableDataPaginationService.reset();
      return;
    }

    this.tableDataPaginationService.initFilters(
      payload,
      this.spanrowParam,
      this.destroy$
    );
  }

  // 🔹 Pagination
  handlePageChange(event: { page: number; pageSize: number }) {
    this.tableDataPaginationService.changePage(event, this.destroy$);
  }

  override ngOnDestroy(): void {
    this.handlereset(false);
  }

  handlereset(show: boolean) {
    if (!show) {
      this.tableDataPaginationService.reset();
    }
  }
}
